// Campus photo for /colleges/lehigh-university: CC BY-SA 4.0, by Kenneth C. Zirkel, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AAlumni_Memorial_Building_Lehigh_University.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/lehigh-university/; credited under the photo.
const photo = {
    "slug": "lehigh-university",
    "alt": "The stone Alumni Memorial Building and its central tower at Lehigh University in Bethlehem, Pennsylvania",
    "src": "/colleges/lehigh-university/campus-1600.webp",
    "srcSmall": "/colleges/lehigh-university/campus-800.webp",
    "srcMid": "/colleges/lehigh-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/lehigh-university/og.jpg",
    "title": "Alumni Memorial Building Lehigh University",
    "author": "Kenneth C. Zirkel",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AAlumni_Memorial_Building_Lehigh_University.jpg",
    "read": "2026-10-02"
};

export default photo;
